import { useEffect, useState } from 'react';
function AnimatedEllipsis() {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prevDots) => {
        if (prevDots.length >= 3) {
          return '';
        }
        return prevDots + '.';
      });
    }, 500); // Change dot every 500ms

    return () => clearInterval(interval);
  }, []);

  return <span className="w-3 inline-block text-left shrink-0 min-w-3">{dots}</span>;
}

export default AnimatedEllipsis;
